import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["id"],
  _excluded2 = ["includeFacets"];
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import createStorage from "services/storage";
import { ApiConfSeriesSearchControllerApi } from "apiclient/api/ApiConfSeriesSearchControllerApi";
import convertToPlainObject from "components/common/utils/convertToPlainObject";
var Storage = createStorage("CONFERENCE-EVENTS");
var API = new ApiConfSeriesSearchControllerApi();
export var fetchConferenceEvents = createAsyncThunk("conferenceEvents/get", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _data$totalElements, _data$content, _data$first, _data$hasContent, _data$last;
    var id, options, _yield$API$searchConf, data, navigators;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, options = _objectWithoutProperties(_ref, _excluded);
            if (options !== null && options !== void 0 && options.page) {
              options.page = +options.page - 1;
            }
            _context.next = 4;
            return API.searchConfEventsPost(_objectSpread({
              seriesId: id
            }, options));
          case 4:
            _yield$API$searchConf = _context.sent;
            data = _yield$API$searchConf.conferenceEvents;
            navigators = _yield$API$searchConf.navigators;
            return _context.abrupt("return", {
              count: (_data$totalElements = data === null || data === void 0 ? void 0 : data.totalElements) !== null && _data$totalElements !== void 0 ? _data$totalElements : 0,
              id: id,
              ids: [],
              entities: convertToPlainObject((_data$content = data === null || data === void 0 ? void 0 : data.content) !== null && _data$content !== void 0 ? _data$content : []),
              navigators: convertToPlainObject(navigators !== null && navigators !== void 0 ? navigators : []),
              // TODO: Here follow the example of cspReducer and store the navigators after calling convertToPlainObject
              // EXAMPLE: navigators: convertToPlainObject(navigators.map((nav) => ({ ...nav, selectedItems: [] }))),
              pagination: {
                first: (_data$first = data === null || data === void 0 ? void 0 : data.first) !== null && _data$first !== void 0 ? _data$first : true,
                hasContent: (_data$hasContent = data === null || data === void 0 ? void 0 : data.hasContent) !== null && _data$hasContent !== void 0 ? _data$hasContent : false,
                last: (_data$last = data === null || data === void 0 ? void 0 : data.last) !== null && _data$last !== void 0 ? _data$last : false,
                number: data !== null && data !== void 0 && data.number ? +(data === null || data === void 0 ? void 0 : data.number) + 1 : 1,
                size: data !== null && data !== void 0 && data.size ? +(data === null || data === void 0 ? void 0 : data.size) : 10,
                totalPages: data !== null && data !== void 0 && data.totalPages ? +(data === null || data === void 0 ? void 0 : data.totalPages) : 0
              }
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
var initialState = {
  status: "init",
  id: undefined,
  count: 0,
  navigators: [],
  entities: [],
  pagination: {},
  expandedNavigators: {},
  isSynced: false,
  filters: {
    includeFacets: {},
    page: 1,
    size: 10
  }
};
var conferenceEventsSlice = createSlice({
  name: "conferenceEvents",
  initialState: initialState,
  reducers: {
    syncStorage: function syncStorage(state) {
      var storaged = Storage.get();
      if (storaged) {
        state.filters = storaged.filters;
        state.expandedNavigators = storaged.expandedNavigators;
      }
      state.isSynced = true;
    },
    updateExpanded: function updateExpanded(state, _ref3) {
      var payload = _ref3.payload;
      state.expandedNavigators = _objectSpread(_objectSpread({}, state.expandedNavigators), payload);
      Storage.set(state);
    },
    updateFilter: function updateFilter(state, _ref4) {
      var _ref4$payload = _ref4.payload;
      _ref4$payload = _ref4$payload === void 0 ? {} : _ref4$payload;
      var key = _ref4$payload.key,
        value = _ref4$payload.value;
      state.filters[key] = value;
      if (key !== "page") {
        state.filters.page = 1;
      }
      Storage.set(state);
    },
    updateFilters: function updateFilters(state, _ref5) {
      var _ref6;
      var _ref5$payload = _ref5.payload;
      _ref5$payload = _ref5$payload === void 0 ? {} : _ref5$payload;
      var _ref5$payload$include = _ref5$payload.includeFacets,
        includeFacets = _ref5$payload$include === void 0 ? [] : _ref5$payload$include,
        rest = _objectWithoutProperties(_ref5$payload, _excluded2);
      state.filters = _objectSpread(_objectSpread(_objectSpread({}, state.filters), rest), {}, {
        includeFacets: (_ref6 = includeFacets !== null && includeFacets !== void 0 ? includeFacets : state.filters.includeFacets) !== null && _ref6 !== void 0 ? _ref6 : {}
      });
      if (!rest.page) {
        state.filters.page = 1;
      }
      Storage.set(state);
    },
    clearFilters: function clearFilters(state) {
      state.filters = initialState.filters;
      Storage.set(state);
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchConferenceEvents.pending, function (state) {
      state.status = "pending";
    }).addCase(fetchConferenceEvents.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      state.status = "done";
      state.count = payload.count;
      state.entities = payload.entities;
      state.navigators = payload.navigators;
      state.pagination = payload.pagination;
      state.id = payload.id;
    }).addCase(fetchConferenceEvents.rejected, function (state) {
      state.status = "error";
    });
  }
});
export var selectConferenceEvents = function selectConferenceEvents(state) {
  return state.conferenceEvents.entities;
};
export var selectConferenceEventsCount = function selectConferenceEventsCount(state) {
  return state.conferenceEvents.count;
};
export var selectConferenceEventsStatus = function selectConferenceEventsStatus(state) {
  return state.conferenceEvents.status;
};
export var selectConferenceEventsNavigators = function selectConferenceEventsNavigators(state) {
  return state.conferenceEvents.navigators;
};
export var selectConferenceEventsPagination = function selectConferenceEventsPagination(state) {
  return state.conferenceEvents.pagination;
};
export var selectFilters = function selectFilters(state) {
  return state.conferenceEvents.filters;
};
export var selectExpanded = function selectExpanded(state) {
  return state.conferenceEvents.expandedNavigators;
};
export var SelectCSE = function SelectCSE(state) {
  return state.conferenceEvents;
};
var actions = conferenceEventsSlice.actions;
export { actions };
export default conferenceEventsSlice.reducer;